import { render, staticRenderFns } from "./CallbackDetails.vue?vue&type=template&id=5bc172a1"
import script from "./CallbackDetails.vue?vue&type=script&lang=js"
export * from "./CallbackDetails.vue?vue&type=script&lang=js"
import style0 from "./CallbackDetails.vue?vue&type=style&index=0&id=5bc172a1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports